import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { CSRFTOKEN } from '../redux/constant/constants';
import { uploadFilesToServer, updateNewPlan, updateSingleImage } from '../serverRequests/requests';
import { nextStep, LibImageAdd, LibPlanAdd, ifloorplanStateAdd, panelumLib } from '../redux/actions/actions';


const UploadFiles = (props) => {
    const [status, setStatus] = useState(0);
    const [filesStatus, setFilesStatus] = useState([]);
    const { ifloorplanNowState,
        levelNowId,
        ifloorplanStateAdd,
        nextStep,
        LibImageAdd,
        LibPlanAdd
    } = props;

    const initFiles = (files) => {
        const w = [];
        for (let i = 0; i < files.length; i++){
            w.push({ id: i, name: files[i].name, selected: true});
        }
        setFilesStatus(w);
    }

    const compressImage = async (file) => {
        const quality = [0.6, 0.4, 0.3, 0.2];
        const maxSize = 2097152;
        var blob = file;
        for (let i = 0; i < quality.length; i++){
            if (blob.size < maxSize){ 
                return blob;
            }
            blob = await (new Promise((resolve, reject) => {
                var image = new Image();
                image.onload = () => {
                    const dataURItoBlob = (dataURI) => {
                        var binary = atob(dataURI.split(',')[1]);
                        var array = [];
                        for(var i = 0; i < binary.length; i++) {
                            array.push(binary.charCodeAt(i));
                        }
                        return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
                    }
                    var canvas = document.createElement('canvas');
                    var ctx = canvas.getContext('2d');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                    blob = dataURItoBlob(canvas.toDataURL('image/jpeg', quality[i]));
                    resolve(blob);
                }
                image.src = URL.createObjectURL(file);
            }))
        }
        return blob;
    }

    const sendFileToServer = async (files) => {

        const config = {
            onUploadProgress: (progressEvent) => {
                const {loaded, total} = progressEvent;
                let percents = Math.floor((loaded * 100) / total );
                setStatus(percents);
            },
            headers: {
                "X-CSRFToken": CSRFTOKEN,
                'content-type': 'multipart/form-data'
            }
        }

        if (props.dropFilesTitle === "360 lib") { //upload 360 images to library
                let form_data = new FormData();
                form_data.append('ifloorplan_id', ifloorplanNowState.id);
                form_data.append('many', true);
                for (var x = 0; x < files.length; x += 1){
                    const compressedFile = await compressImage(files[x]);
                    form_data.append('image_'+x, compressedFile, files[x].name);
                }
                uploadFilesToServer("/api/panelum/", form_data, config)
                    .then(res => {
                        props.setAnimation(animationSaved=>animationSaved+1);
                        props.panelumLib(res.data);
                        if(props.prev_step === "template"){
                            nextStep("image library", "template");
                            return 1;
                        }
                        if(props.prev_step === "not redirect lib"){
                            nextStep('cams position', "not redirect lib");
                            return 1;
                        }
                        nextStep("360 library", "_");
                    })
        }
        if (props.dropFilesTitle === "single 360") { //upload single file to 360  library
                let form_data = new FormData();
                form_data.append('ifloorplan_id', ifloorplanNowState.id);
                const compressedFile = await compressImage(files[0]);
                form_data.append('image', compressedFile, files[0].name);
                uploadFilesToServer("/api/panelum/", form_data, config)
                    .then(res => {
                        props.setAnimation(animationSaved=>animationSaved+1);
                        props.panelumLib(res.data);
                        nextStep("360 library", "_");
                    })
        }
        const setDefaultPlanSize = (img) => {
            let plan = new Image();
            plan.style.width="100%";
            plan.onload = (src) => {
                let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                newState.level[props.levelNowId].plan_width = plan.width/plan.height < 8/9 ? (plan.width*50.625/plan.height) : 45;
                newState.level[props.levelNowId].plan_level[0].img = img.plan_image;
                newState.level[props.levelNowId].plan_level[0].img_id = img.id
                props.ifloorplanStateAdd(newState);
                if(props.prev_step === "template"){
                    nextStep("upload images", "template");
                } else {
                    nextStep("upload images", "_");
                }
            }
            plan.src = img.plan_image;
        }

        if (props.dropFilesTitle === "PLANS") { //upload to plan library
                let form_data = new FormData();
                form_data.append('ifloorplan_id', ifloorplanNowState.id);
                for (var x = 0; x < files.length; x += 1){
                    const compressedFile = await compressImage(files[x]);
                    form_data.append('plan_image_'+x, compressedFile, files[x].name);
                }
                uploadFilesToServer("/api/imageplanuload/", form_data, config)
                    .then(res => {
                        props.setAnimation(animationSaved=>animationSaved+1);
                        let newState = JSON.parse(JSON.stringify(ifloorplanNowState));
                        newState.level[props.levelNowId].plan_level[0].img = res.data[props.levelNowId].plan_image; //set first plan to ifloorplan
                        newState.level[props.levelNowId].plan_level[0].img_id = res.data[props.levelNowId].id;
                        ifloorplanStateAdd(newState); //update state ifloorplan
                        LibPlanAdd(res.data);  //add to library
                        setDefaultPlanSize(res.data[props.levelNowId])
                    })
        }
        if (props.dropFilesTitle === "IMAGES") {  //upload to image library
            let form_data = new FormData();
            form_data.append('ifloorplan_id', ifloorplanNowState.id);
            form_data.append('level_id', ifloorplanNowState.level[props.levelNowId].id);
            for (var x = 0; x < files.length; x += 1){
                const compressedFile = await compressImage(files[x]);
                form_data.append('image_'+x, compressedFile, files[x].name);
            }
            uploadFilesToServer("/api/imageupload/", form_data, config)
                    .then(res => {
                        props.setAnimation(animationSaved=>animationSaved+1);
                        LibImageAdd(res.data);  //add to library
                        if(props.prev_step === "new level"){
                            props.nextStep("image library", props.prev_step);
                            return 1;
                        }
                        if(props.prev_step === "exist images"){
                            props.nextStep("image library", props.prev_step);
                            return 1;
                        }
                        if(props.prev_step === 'image library'){
                            props.nextStep("image library", "_");
                        } else {
                            if(props.prev_step === "template"){
                                props.nextStep("360 library upload", "template");
                            } else {
                                props.nextStep("360 library upload", "_");
                            }
                        }
                    })
        }
        if (props.dropFilesTitle === "PLAN") {
                let form_data = new FormData();
                form_data.append('ifloorplan_id', ifloorplanNowState.id);
                for (var x = 0; x < files.length; x += 1){
                    const compressedFile = await compressImage(files[x]);
                    form_data.append('plan_image_'+x, compressedFile, files[x].name);
                }
                uploadFilesToServer("/api/imageplanuload/", form_data, config)
                    .then(res => {
                        props.setAnimation(animationSaved=>animationSaved+1);
                        LibPlanAdd(res.data);
                        nextStep("plan library", props.prev_step);
                    })
        }
        if (props.dropFilesTitle === "IMAGE") {  //upload to image library
            let form_data = new FormData();
            form_data.append('ifloorplan_id', ifloorplanNowState.id);
            form_data.append('level_id', ifloorplanNowState.level[props.levelNowId].id);
            for (var x = 0; x < files.length; x += 1){
                const compressedFile = await compressImage(files[x]);
                form_data.append('image_'+x, compressedFile, files[x].name);
            }
            uploadFilesToServer("/api/imageupload/", form_data, config)
                    .then(res => {
                        props.setAnimation(animationSaved=>animationSaved+1);
                        LibImageAdd(res.data);  //add to library
                        props.nextStep("image library", "_");
                    })
        }
        if (props.dropFilesTitle === "IMAGE SINGLE UPLOAD") {  //upload to image library
            let form_data = new FormData();
            form_data.append('ifloorplan_id', ifloorplanNowState.id);
            form_data.append('id', props.update_image_id);
            const compressedFile = await compressImage(files[0]);
            form_data.append('image', compressedFile, files[0].name);
            updateSingleImage("/api/imageupload/", form_data, config)
                    .then(res => {
                        props.setAnimation(animationSaved=>animationSaved+1);
                        LibImageAdd(res.data);  //add to library
                        if(props.prev_step === "update single image") {
                            let new_image = res.data.find(el => el.id === props.update_image_id);
                            let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                            for (let i = 0; i < newState.level.length; ++i) {
                                for (let j = 0; j < newState.level[i].images.length; ++j) {
                                    if (newState.level[i].images[j].img_id === props.update_image_id) {
                                        newState.level[i].images[j].img = new_image.image
                                    }
                                } 
                            }
                            props.ifloorplanStateAdd(newState);
                        }
                        props.nextStep("image library", "_");
                    })
        }
        if (props.dropFilesTitle === "360 IMAGE SINGLE UPLOAD") {
            let form_data = new FormData();
            form_data.append('ifloorplan_id', ifloorplanNowState.id);
            form_data.append('id', props.update_360_id);
            const compressedFile = await compressImage(files[0]);
            form_data.append('image', compressedFile, files[0].name);
            updateSingleImage("/api/panelum/", form_data, config)
                    .then(res => {
                        props.setAnimation(animationSaved=>animationSaved+1);
                        props.panelumLib(res.data);  //add to library
                        if (props.prev_step === "update single 360") {
                            let new_image = res.data.find(el => el.id === props.update_360_id);
                            let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                            for (let i = 0; i < newState.level.length; ++i) {
                                for (let j = 0; j < newState.level[i].panelum.length; ++j) {
                                    if (newState.level[i].panelum[j].id_lib_img === props.update_360_id) {
                                        newState.level[i].panelum[j].img = new_image.image;
                                    }
                                }
                            }
                            props.ifloorplanStateAdd(newState);
                        }
                        props.nextStep("360 library", "_");
                    })
        }
        if (props.dropFilesTitle === "UPDATE SINGLE PLAN") {  //upload to image library
            let form_data = new FormData();
            form_data.append('ifloorplan_id', ifloorplanNowState.id);
            form_data.append('id', props.update_plan_image);
            const compressedFile = await compressImage(files[0]);
            form_data.append('plan', compressedFile, files[0].name);
            form_data.append('level_id', ifloorplanNowState.level[props.levelNowId].id);
            updateSingleImage("/api/imageplanuload/", form_data, config)
                    .then(res => {
                        props.setAnimation(animationSaved=>animationSaved+1);
                        LibPlanAdd(res.data);  //add to library
                        let new_image = res.data.find(el => el.id === props.update_plan_image);
                        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                        for (let i = 0; i < newState.level.length; ++i ){
                            if (newState.level[i].plan_level[0].img_id === props.update_plan_image) {
                                newState.level[i].plan_level[0].img = new_image.plan_image;
                            }
                        }
                        props.ifloorplanStateAdd(newState);
                        props.nextStep("plan library", "_");
                    })
        }
    }

    useEffect(() => {
        initFiles(props.dropFiles);
        sendFileToServer(props.dropFiles);
        if(props.setShowTools)
            props.setShowTools(false);
    }, []);

    let title = "";
    switch (props.dropFilesTitle) {

        case "PLANS":
            title = "Floor plans files are uploading...";
            break;

        case "IMAGES":
            title = "Images files are uploading...";
            break;

        case "360 lib":
            title = "360 images files are uploading...";
            break;

        default:
            title = "";
            break;
    }

    return (
        <div className="status_upload">
            <div className="titleUpload">{title}</div>
            <div className="items">
                {
                    filesStatus.map((value, index) => {
                        return <div key={index} className="item">
                                    <p>{value.name}</p>
                                    <div className="progress"><div className="status" style={{width:status+'%'}}></div></div>
                                </div>
                    })
                }
            </div>
        </div>
    );
}

const putState = (state) => {
    return {
        step: state.step,
        dropFiles: state.dropFiles,
        dropFilesTitle: state.dropFilesTitle,
        levelNowId: state.levelNowId,
        ifloorplanNowState: state.ifloorplanNowState,
        prev_step: state.prev_step,
        update_image_id: state.update_image_id,
        update_plan_image: state.update_plan_image,
        update_360_id: state.update_360_id,
        LibraryImage: state.LibraryImage,
    }
}

const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        LibPlanAdd: (array) => dispatch(LibPlanAdd(array)),
        LibImageAdd: (array) => dispatch(LibImageAdd(array)),
        panelumLib: (items) => dispatch(panelumLib(items)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan))
    }
}


export default connect(putState, putActions) (UploadFiles);
